import { Flex, Heading, Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { SourcingEventV2Dto } from "../../../../../autogen/bff-api";
import { LastChangedTag } from "../../../../../common/editing/LastChangedTag/LastChangedTag";
import { useProcurementTerms } from "../../../../../common/terminology/useProcurementTerms";

interface Props {
  title: string;
  modifiedAt: string;
  contextType: SourcingEventV2Dto["eventContext"]["type"];
  isChangeInFlight: boolean;
}

export const EventHeader = ({ title, modifiedAt, contextType, isChangeInFlight }: Props) => {
  const { t } = useTranslation();
  const terms = useProcurementTerms();
  const untitledLabel =
    contextType === "Public"
      ? t("New public sourcing event")
      : contextType === "Private"
        ? terms.newSimplifiedDraft
        : t("New sourcing event");

  return (
    <>
      <Heading
        as="h2"
        size="md"
        width="full"
        textOverflow="ellipsis"
        overflow="hidden"
        whiteSpace="nowrap"
        mb="2"
      >
        {title || untitledLabel}
      </Heading>
      <Flex columnGap="1">
        <Tag size="sm" colorScheme={isChangeInFlight ? "orange" : "teal"} variant="subtle">
          {isChangeInFlight ? t("Change in progress") : t("Draft")}
        </Tag>
        <LastChangedTag timestamp={modifiedAt} />
      </Flex>
    </>
  );
};
